import { Icon, Row, Text } from "app/components";
import { colors, spacing } from "app/utils/theme";

import styled from "styled-components";
import { useState } from "react";

const Tile = ({ label, onClick, icon, onDelete, className }) => {
  const [showDelete, setShowDelete] = useState(false);
  return (
    <TileContainer
      className={className}
      onClick={onClick}
      onMouseEnter={() => {
        if (!showDelete) {
          setShowDelete(true);
        }
      }}
      onMouseLeave={() => {
        if (showDelete) {
          setShowDelete(false);
        }
      }}
    >
      {icon && (
        <Icon
          data={{
            icon: icon,
            color: "var(--grey7)",
            size: 20,
          }}
        />
      )}
      <Row justifyContent="space-between" alignItems="center" width="100%">
        <Text
          data={{
            cursor: "pointer",
            text: label,
            fontStyle: "headingSm",
          }}
        />
        {showDelete && onDelete && (
          <Icon
            data={{
              icon: "FiTrash",
              hover: true,
              onClick: (e) => {
                e.stopPropagation();
                onDelete();
              },
              color: "var(--grey7)",
              size: 18,
            }}
          />
        )}
      </Row>
    </TileContainer>
  );
};

export default Tile;

const TileContainer = styled.div`
  border: 1px solid var(--grey21);
  padding: 9px 12px 9px 12px;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: ${spacing.s3};
  align-items: center;
  &:hover {
    background: var(--grey1);
  }
`;
